import { NurseryModel } from "./nursery.model";

export class NurseryWithPromoModel extends NurseryModel {

    public promotionPhotosphereUuid: string;
    public promotionUuid: string;

    constructor(value: unknown) {
        super(value);
        this.promotionPhotosphereUuid = value["promotion_photosphere_uuid"];
        this.promotionUuid = value["promotion_uuid"];
    }
}
